/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  InlineLoading,
  FormGroup,
  TextArea,
  DatePickerSkeleton,
  ComposedModal,
  ModalHeader,
  ModalBody,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
  Form,
  FormLabel,
  Loading,
  TextInput,
  ModalFooter,
  Tabs,
  Tab,
  Toggle
} from 'carbon-components-react';
import moment from 'moment';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import View16 from '@carbon/icons-react/lib/view/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Attachment16 from '@carbon/icons-react/lib/attachment/16';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import { api } from '../../../../helpers/api/api';
import { IsInRole, IsEnabled, IsEditable } from '../../../../helpers/authorization/Policies';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import {
  getError,
  getSuccess,
  sizeFormat,
  apioperation,
  entitiesLabels,
  STATUS,
  DateFormat,
} from '../../../../helpers/Constants';
import DateTimePicker from '../../../../helpers/DateTimePicker';
import { FindGHRSEmployer } from '../../../common/FindGHRSEmployer';
import { StatusTag } from '../../../../helpers/PageBreadCrumb';
import { AppContext } from '../../../../helpers/context/AppContext';

import CheckListQuestionAnswer from './CheckListQuestionAnswer';
import FileUpload from '../../../common/FileUpload';
import { ConfirmAlertCustom } from '../../../../helpers/ConfirmAlertCustom';
import CheckListRequirement from './CheckListRequirement';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import DownLoadButton from '../../../common/FileDownloadButton';

import { Online, Offline } from '../../../common/OnLineOffLine';
import { FindSaipemCompilers } from '../../../common/FindSaipemCompilers';

export class DrillReportSummary extends Component {
  carModelProps = () => ({
    duedate: null,
    id: null,
    carOwner: {},
    idOwner: null,
    idOwnerSaipem: null,
    idAnswer: null,
    idStatus: null,
    idDrillCheckListRequirementAnswer: null,
    idDrillReport: null,
    drillCARCode: '',
    detailsOfInefficiency: null,
    findingDescription: null,
    identifiedCorrectiveAction: null,
    status: {},
    drillReport: {},
    drillCheckListRequirementAnswer: {},
  });

  ownerModelprops = () => ({
    fullname: null,
    email: null,
  });

  constructor(props) {
    super(props);
    this.state = {
      drillReport: this.props.drillReport,
      carModel: {
        ...this.carModelProps(),
      },
      ownerModel: {
        ...this.ownerModelprops(),
      },

      isOpenModalGHRS: false,
      isOpenModalCar: false,
    };

    this.getTemplate = this.getTemplate.bind(this);
    this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
    this.updateStateDPCAR = this.updateStateDPCAR.bind(this);
    this.onDetailsOfInefficiencyChange = this.onDetailsOfInefficiencyChange.bind(this);
    this.onFindingDescriptionChange = this.onFindingDescriptionChange.bind(this);
    this.onCorrectiveActionChange = this.onCorrectiveActionChange.bind(this);
    this.setEmployer = this.setEmployer.bind(this);
    this.showAddRequirement = this.showAddRequirement.bind(this);
    this.onUploadAnswer = this.onUploadAnswer.bind(this);
    this.saveCar = this.saveCar.bind(this);
    this.validationsAnswer = new SimpleReactValidator();
    this.validationsNotifications = new SimpleReactValidator();
    this.validationsCar = new SimpleReactValidator();
  }


  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.drillReport !== this.props.drillReport) {
      this.state = {
        ...this.state,
        drillReport: nextProps.drillReport,
      };
    }
  }

  updateCheckList = async () => {
    // if (this.validationsAnswer.allValid()) {
      this.props.updateAnswers(this.state.drillReport);
    // } else {
    //   this.validationsAnswer.showMessages();
    //   showNotification.warning(`${entitiesLabels.WARNING}`,
    //     `${entitiesLabels.EMERGENCYDRILL_REPORT} required fields are missing  `
    //   );
    //   this.forceUpdate();
    // }
  };

  showRequirment = () => {
    this.setState({
      isLoadtemplate: true,
    });
  };

  getTemplate = () => {
    const result = [];
    const map = new Map();
    this.state.drillReport.drillCheckListRequirementAnswers.forEach((answer) => {
      if (answer.question?.idDrillCheckListTemplate != null &&
          !map.has(answer.question.idDrillCheckListTemplate)) {
        const until = new Date(answer.question.drillCheckListTemplate.validUntil);
        if (until > new Date()) {
          map.set(answer.question.idDrillCheckListTemplate, true);
          result.push({ ...answer.question.drillCheckListTemplate,
                       /* DEV550 */ active: answer.active });
        }
      }
    });
    const orderResult = [];


    result.forEach((item) => {
      orderResult.push(item);
    });
    return orderResult;
  };

  toggleActiveTemplateQuestions = (idDrillCheckListTemplate) => {
    const updatedAnswer = this.state.drillReport.drillCheckListRequirementAnswers.map((answer) => {
      if (answer.question?.idDrillCheckListTemplate === idDrillCheckListTemplate || answer.requirement?.idDrillCheckListTemplate === idDrillCheckListTemplate) { //RITM1267587
        return { ...answer, active: !answer.active };
      }
      return { ...answer };
    });
    this.setState((prevState) => {
      const copyOfDrillReport = { ...prevState.drillReport };
      copyOfDrillReport.drillCheckListRequirementAnswers = updatedAnswer;
      return { drillReport: copyOfDrillReport };
    });
  }

  renderRequirementDeleteModal = () => {
    const modalHeader = {
      title: 'Delete Custom Requirement',
      iconDescription: 'Close',
      buttonOnClick: () => this.handleRequirementDeleteCancel(),
    };
    return (
      this.state.modalDeleteRequirementVisible && (
        <ComposedModal
          className="light-modal"
          open
          danger="false"
          onClose={() => {
            this.handleRequirementDeleteCancel();
          }}
        >
          <ModalHeader className="margin-modal" title={modalHeader.title} iconDescription={modalHeader.iconDescription} buttonOnClick={modalHeader.buttonOnClick}>
            <p />
          </ModalHeader>
          {this.state.isDeletingReq ? <Loading /> : ''}
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">
                    Press confirm to delete selected custom requirement
                  </h5>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={this.handleRequirementDeleteCancel}>
              Cancel
            </Button>
            <Button kind="primary" onClick={this.handleRequirementDelete}>
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      )
    );
  };

  confirmDeleteCAR = (id, idAnswer) => {
    this.setState({
      idAnswerToDelete: idAnswer,
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  //* *************** ATTACHMENT **************** START
  showModalAttachment = (id) => {
    this.setState({
      idAnswerAttachment: id,
      isOpenModalAttachment: true,
    });
  };

  closeModalAttachment = () => {
    this.setState({
      isOpenModalAttachment: false,
    });
  };

  modalAttachment(user) {
    const modalHeader = {
      title: 'Attachments',
      iconDescription: 'Close',
      buttonOnClick: () => this.closeModalAttachment(),
    };

    return (
      <>
        {this.state.isOpenModalAttachment ? (
          <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
            <ModalHeader className="margin-modal" title={modalHeader.title} iconDescription={modalHeader.iconDescription} buttonOnClick={modalHeader.buttonOnClick}>
              <p />
            </ModalHeader>
            <ModalBody className="margin-modal">
              {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
                <div className="bx--col-lg-6 bx--col-md-6 element-detail-layout">
                  <FileUpload
                    Container="saipem"
                    StoragePath="drillReport"
                    onUpload={this.onUploadAnswer}
                    disabled={this.props.editingDisabled}
                  />
                </div>
              )}
              <TableContainer>
                <Table>
                  <TableHead className="colorgray">
                    <TableRow>
                      <TableHeader>Name</TableHeader>
                      <TableHeader>Size</TableHeader>
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {this.state.drillReport?.drillCheckListRequirementAnswers.map((dclra) =>
                     dclra.attachments !== undefined && dclra.attachments != [] && 
                      dclra.id === this.state.idAnswerAttachment ? (dclra.attachments < 1 ? 
                      (
                        <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                      ) :
                      (
                        dclra.attachments.map((item) => (
                          <TableRow key={`row_${item.id}`}>
                            <TableCell key={`cell_1_${item.id}`}>
                              {item?.attachment?.name}
                            </TableCell>
                            <TableCell key={`cell_2_${item.id}`}>
                              {sizeFormat(item?.attachment?.size)}
                            </TableCell>
                            <TableCell
                              key={`action-${item.id}`}
                              className="tableActions align-center"
                            >
                              {this.state.downloading === item.id ? (
                                <div>
                                  <InlineLoading
                                    description=""
                                    iconDescription="downloading.."
                                    status="active"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <Online>
                                    <DownLoadButton
                                      onError={(error) => {
                                        showNotification.error(`${entitiesLabels.ERROR}`,
                                          getError(
                                            error,
                                            entitiesLabels.FileUpload,
                                            apioperation.GET
                                          )
                                        );
                                      }}
                                      onDownLoadStart={() =>
                                        this.setState({
                                          downloading: item.id,
                                        })
                                      }
                                      onDownLoadEnd={() => this.setState({ downloading: null })}
                                      apiUrl={`/drill/report/${this.props.drillReport.id}/answer/${this.state.idAnswerAttachment}/attachment/${encodeURIComponent(item?.attachment?.fileIdentifier)}`} //RITM1094125
                                      fileName={item?.attachment?.name}
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Download"
                                      kind="ghost"
                                      disabled={this.props.editingDisabled}
                                    />
                                  </Online>
                                  <Offline>
                                    <Button
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Download"
                                      kind="ghost"
                                      disabled
                                    />
                                  </Offline>
                                  {/* <Button
                                      onClick={() =>
                                        this.downloadAttachmentAnswer(item.id)
                                      }
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Download"
                                      kind="ghost"
                                      disabled={this.props.editingDisabled}
                                    /> */}
                                  <Online>
                                    {(IsInRole(user, 'Administrator') ||
                                      IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
                                      <Button
                                        onClick={() => this.onDeleteAttachmentAnswer(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled={this.props.editingDisabled}
                                      />
                                    )}
                                    {' '}
                                  </Online>
                                  <Offline>
                                    <Button
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                      disabled
                                    />
                                  </Offline>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      )
                      )
                      : (
                        ''
                       )

                      // dclra.attachments?.length !== 0 && 
                      // dclra.id === this.state.idAnswerAttachment ? (
                      //   dclra.attachments < 1 ? (
                      //     <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                      //   ) : (
                      //     dclra.attachments.map((item) => (
                      //       <TableRow key={`row_${item.id}`}>
                      //         <TableCell key={`cell_1_${item.id}`}>
                      //           {item?.attachment?.name}
                      //         </TableCell>
                      //         <TableCell key={`cell_2_${item.id}`}>
                      //           {sizeFormat(item?.attachment?.size)}
                      //         </TableCell>
                      //         <TableCell
                      //           key={`action-${item.id}`}
                      //           className="tableActions align-center"
                      //         >
                      //           {this.state.downloading === item.id ? (
                      //             <div>
                      //               <InlineLoading
                      //                 description=""
                      //                 iconDescription="downloading.."
                      //                 status="active"
                      //               />
                      //             </div>
                      //           ) : (
                      //             <div>
                      //               <Online>
                      //                 <DownLoadButton
                      //                   onError={(error) => {
                      //                     showNotification.error(`${entitiesLabels.ERROR}`,
                      //                       getError(
                      //                         error,
                      //                         entitiesLabels.FileUpload,
                      //                         apioperation.GET
                      //                       )
                      //                     );
                      //                   }}
                      //                   onDownLoadStart={() =>
                      //                     this.setState({
                      //                       downloading: item.id,
                      //                     })
                      //                   }
                      //                   onDownLoadEnd={() => this.setState({ downloading: null })}
                      //                   apiUrl={`/drill/report/${this.props.drillReport.id}/answer/${this.state.idAnswerAttachment}/attachment/${item?.attachment?.fileIdentifier}`}
                      //                   fileName={item?.attachment?.name}
                      //                   size="small"
                      //                   renderIcon={View16}
                      //                   iconDescription="Download"
                      //                   kind="ghost"
                      //                   disabled={this.props.editingDisabled}
                      //                 />
                      //               </Online>
                      //               <Offline>
                      //                 <Button
                      //                   size="small"
                      //                   renderIcon={View16}
                      //                   iconDescription="Download"
                      //                   kind="ghost"
                      //                   disabled
                      //                 />
                      //               </Offline>
                      //               {/* <Button
                      //                   onClick={() =>
                      //                     this.downloadAttachmentAnswer(item.id)
                      //                   }
                      //                   size="small"
                      //                   renderIcon={View16}
                      //                   iconDescription="Download"
                      //                   kind="ghost"
                      //                   disabled={this.props.editingDisabled}
                      //                 /> */}
                      //               <Online>
                      //                 {(IsInRole(user, 'Administrator') ||
                      //                   IsInRole(user, 'Compiler')) && (
                      //                   <Button
                      //                     onClick={() => this.onDeleteAttachmentAnswer(item.id)}
                      //                     size="small"
                      //                     renderIcon={Delete16}
                      //                     iconDescription="Delete"
                      //                     kind="ghost"
                      //                     disabled={this.props.editingDisabled}
                      //                   />
                      //                 )}
                      //                 {' '}
                      //               </Online>
                      //               <Offline>
                      //                 <Button
                      //                   size="small"
                      //                   renderIcon={Delete16}
                      //                   iconDescription="Delete"
                      //                   kind="ghost"
                      //                   disabled
                      //                 />
                      //               </Offline>
                      //             </div>
                      //           )}
                      //         </TableCell>
                      //       </TableRow>
                      //     ))
                      //   )
                      // ) : (
                      //   ''
                      // )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </ModalBody>
          </ComposedModal>
        ) : (
          <div />
        )}
      </>
    );
  }

  async onDeleteAttachmentAnswer(Id) {
    this.props.deleteAnswerAttachment(Id, this.state.idAnswerAttachment);
  }

  downloadAttachmentAnswer = async (Id) => {
    this.props.downloadAnswerAttachment(Id, this.state.idAnswerAttachment);
  };

  async onUploadAnswer(fileIdentifier, fileName, fileType, size) {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    this.props.uploadAnswerAttachment(this.state.idAnswerAttachment, newAttach);
  }
  //* *************** ATTACHMENT **************** END

  newCheckListRequirementAdded = (item) => {
    const { drillCheckListRequirementAnswers } = this.state.drillReport;
    let count = 0;
    // for (const answer in drillCheckListRequirementAnswers) {
    //   if (answer != null) count += 1;
    // }
    Object.keys(drillCheckListRequirementAnswers).forEach((key) => {
      if (drillCheckListRequirementAnswers[key] != null) count += 1;
    });
    drillCheckListRequirementAnswers[count] = item;
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalAddRequirementVisible = !prevState.modalAddRequirementVisible;
      state.isSubmitted = false;
      state.drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      // this.repository.updateCachedAudit(this.state.drillReport);      TODO
      return state;
    });
  };
  
  getNewCAR = () => (({ idAnswer, ...object }) => object)(this.state.carModel)

  saveCar = () => {
    if (this.validationsCar.allValid()) {
      let idDrillReport = null;
      const { idAnswer } = this.state?.carModel; 
      this.setState({
        isSaveCar: true,
      });
      if (!this.state.isUpdateDocument) {
        idDrillReport = this.state.drillReport.id;
        // let { idAnswer } = this.state.carModel;
        if (idAnswer == null || idDrillReport == null) return;
        this.setState((prevState) => (
          
          { carModel: {
            ...prevState.carModel,
            idAnswer,
          } }));
      }

      const newCar = this.getNewCAR();

      const method = this.state.isUpdateDocument
        ? api.put(`drill/report/answer/car/${this.state.carModel.id}`, newCar)
        : api.post(`drill/report/${idDrillReport}/answer/${idAnswer}/car`, newCar);

      method
        .then(async (response) => {
          if (response.status === 200) {
            if (!this.state.isUpdateDocument) {
              newCar.idStatus = 1;
              newCar.status = {
                caManagementName: 'Draft',
                carManagementName: 'Assigned',
                carSimplifiedName: 'Opened',
                createdBy: 'System',
                createdOn: null,
                id: 1,
                name: 'Draft',
                planningName: 'Draft',
                reportingName: 'Opened',
              };
              newCar.drillCheckListRequirementAnswer = 
                this.state.drillReport.drillCheckListRequirementAnswers.find(
                  (qa) => qa.id === idAnswer
                );
            }
            newCar.idDrillReport = this.state.drillReport.id;
            newCar.drillReport = this.state.drillReport;
            newCar.drillCARCode = response.data?.drillCarCode;
            // await DrillRepository.updateCachedCarList(newCar);
            showNotification.success(`${entitiesLabels.SUCCESS}`,
              getSuccess(
                entitiesLabels.EMERGENCYDRILL_CAR,
                this.state.isUpdateDocument ? apioperation.PUT : apioperation.POST
              )
            );

            if (!this.state.isUpdateDocument) {
              const { drillCheckListRequirementAnswers } = this.state.drillReport;

              const index = drillCheckListRequirementAnswers.findIndex((qa) => qa.id === idAnswer);

              drillCheckListRequirementAnswers[index].car = response?.data?.drillCar
                ? response?.data?.drillCar
                : newCar;
              this.setState((prevState) => {
                const state = { ...prevState };
                state.drillReport.drillCheckListRequirementAnswers =
                 drillCheckListRequirementAnswers;
                return state;
              });
              this.closemodalCar();
            } else {
              const { drillCheckListRequirementAnswers } = this.state.drillReport;

              const index = drillCheckListRequirementAnswers.findIndex(
                (qa) => qa.id === this.state.carModel.idAnswer
              );

              drillCheckListRequirementAnswers[index].car = response?.data
                ? response?.data
                : newCar;
              this.setState((prevState) => {
                const state = { ...prevState };
                state.drillReport.drillCheckListRequirementAnswers =
                 drillCheckListRequirementAnswers;
                return state;
              });
              this.closemodalCar();
            }
            this.closemodalCar();
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.POST));
        })
        .finally(() => {
          this.closemodalCar();
          this.setState(
            {
              isSaveCar: false,
            },
            () => {
              // this.getSelectedEntityRoles();
            }
          );
        });
    } else {
      this.validationsCar.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        `${entitiesLabels.EMERGENCYDRILL_REPORT} required fields are missing  `
      );

      this.forceUpdate();
    }
  };

  closemodalCar = () => {
    this.setState({
      carModel: {
        ...this.carModelProps(),
      },
      ownerModel: {
        ...this.ownerModelprops(),
      },
      isUpdateDocument: false,
      isOpenModalCar: false,
    });
    this.validationsCar = new SimpleReactValidator();
  };

  showGHRS = () => {
    const statusCopy = { ...this.state };
    statusCopy.isOpenModalGHRS = true;
    this.setState(statusCopy);
  };

  handleChangeMode = (m) => {
    if (m === 0) {
      this.setState({ mode: m, isOpenModalGHRS: false });
    } else {
      this.setState({ mode: m, isOpenModalGHRS: true });
    }
  };

  onDetailsOfInefficiencyChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ carModel: {
        ...prevState.carModel,
        detailsOfInefficiency: value,
      } }));
  }

  onFindingDescriptionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ carModel: {
        ...prevState.carModel,
        findingDescription: value,
      } }));
  }

  onCorrectiveActionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ carModel: {
        ...prevState.carModel,
        identifiedCorrectiveAction: value,
      } }));
  }

  updateStateDPCAR = (inputName, inputValue) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.duedate = inputValue;
    this.setState(statusCopy);
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state };
      statusCopy.ownerModel.fullname = employer.fullname;
      statusCopy.ownerModel.email = employer.email;
      statusCopy.carModel.carOwner = employer;
      statusCopy.carModel.idOwner = employer.id;
      statusCopy.carModel.owner = employer;
      this.setState(statusCopy);

      this.setState({ isOpenModalGHRS: false });
    }
  };

  handleChangeGHRSModal() {
    const statusCopy = { ...this.state };
    statusCopy.isOpenModalGHRS = false;
    this.setState(statusCopy);
  }

  // /Requirement
  showAddRequirement = () => {
    this.setState((oldState) => ({
      modalAddRequirementVisible: !oldState.modalAddRequirementVisible,
    }));
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state };
      statusCopy.ownerModel.fullname = employer.fullname;
      statusCopy.ownerModel.email = employer.email;
      statusCopy.carModel.carOwner = employer;
      statusCopy.carModel.idOwner = employer.id;
      statusCopy.carModel.owner = employer;
      statusCopy.carModel.idOwnerSaipem = null;
      statusCopy.carModel.ownerSaipem = null;
      this.setState(statusCopy);

      this.setState({ isOpenModalGHRS: false });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      this.setState((prevState) => {
        const statusCopy = { ...prevState };
        statusCopy.ownerModel.fullname = employer.fullname;
        statusCopy.ownerModel.email = employer.email;
        statusCopy.carModel.carOwner = employer;
        statusCopy.carModel.idOwnerSaipem = employer.id;
        statusCopy.carModel.ownerSaipem = employer;
        statusCopy.carModel.idOwner = null;
        statusCopy.carModel.owner = null;

        return { model: statusCopy, mode: 0, isOpenModalGHRS: false };
    });
    }
  };
  
  showModalCar = (idAnswer, requirement) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.id = uuid();
    statusCopy.carModel.idDrillReport = this.state.drillReport.id;
    statusCopy.carModel.idDrillCheckListRequirementAnswer = 
      this.state.drillReport.drillCheckListRequirementAnswers[0].id;
    statusCopy.carModel.idStatus = 1;
    statusCopy.carModel.idAnswer = idAnswer;
    statusCopy.carModel.requirementCode = requirement;
    statusCopy.isOpenModalCar = true;
    statusCopy.carModel.detailsOfInefficiency = null;
    statusCopy.carModel.findingDescription = null;
    statusCopy.carModel.identifiedCorrectiveAction = null;
    statusCopy.carModel.drillCheckListRequirementAnswer = 
    this.state.drillReport.drillCheckListRequirementAnswers.find(
      (qa) => qa.id === idAnswer
    ); //Framework upgrade from 2.2 to 8.0
    this.setState(statusCopy);
  };

  getCarOwnerMail = (car) => {
    if (car.owner != null) {
      return car.owner.email;
    } 
    if (car.ownerSaipem != null) {
      return car.ownerSaipem.email;
    }
    return '';
  }

  getCarOwnerFullName = (car) => {
    if (car.owner != null) {
      return car.owner.name;
    } 
    if (car.ownerSaipem != null) {
      return car.ownerSaipem.name;
    }
    return '';
  }

  showModalUpdateCar = (idAnswer, car) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.id = car.id;
    statusCopy.carModel.idDrillCheckListRequirementAnswer = car.idDrillCheckListRequirementAnswer;
    statusCopy.carModel.idAnswer = idAnswer;
    statusCopy.carModel.duedate = moment(car.dueDate).format('YYYY-MM-DD');
    statusCopy.carModel.detailsOfInefficiency = car.detailsOfInefficiency;
    statusCopy.carModel.findingDescription = car.findingDescription;
    statusCopy.carModel.identifiedCorrectiveAction = car.identifiedCorrectiveAction;
    statusCopy.carModel.idOwner = car.idOwner;
    statusCopy.carModel.idOwnerSaipem = car.idOwnerSaipem;
    statusCopy.carModel.idStatus = car.idStatus;
    statusCopy.carModel.status = car.status;
    statusCopy.ownerModel.email = this.getCarOwnerMail(car);
    statusCopy.ownerModel.fullname = this.getCarOwnerFullName(car);
    statusCopy.isOpenModalCar = true;
    statusCopy.isUpdateDocument = true;

    this.setState(statusCopy);
  };

  modalCar() {
    let diffduedate = true;
    if (this.state.drillReport.deliveryDate !== '0001-01-01T00:00:00Z') {
      diffduedate =
        !this.state.carModel.duedate ||
        moment(this.state.carModel.duedate).isSameOrAfter(
          moment(this.state.drillReport.deliveryDat),
          'day'
        );
    }
    const modalHeader = {
      title: this.state.isUpdateDocument ? 'Edit Car' : 'Add new Car',
      iconDescription: 'Close',
      buttonOnClick: () => this.closemodalCar(),
    };
    const validationCar = {
      detailsOfInefficiency: this.validationsCar.message(
        'Details of inefficiency',
        this.state.carModel?.detailsOfInefficiency,
        'required'
      ),
      findingDescription: this.validationsCar.message(
        'Finding Description',
        this.state.carModel?.findingDescription,
        'required'
      ),
      correctiveAction: this.validationsCar.message(
        'Corrective Action to be implemented',
        this.state.carModel?.identifiedCorrectiveAction,
        'required'
      ),
      dueDate: this.validationsCar.message('DueDate', this.state.carModel?.duedate, 'required'),
      email: this.validationsCar.message('Car Owner', this.state.ownerModel?.email, 'required'),
      duedate: this.validationsCar.message('Due Date ', diffduedate, 'accepted'),
    };
    return (
      <>
        {this.state.isOpenModalCar && !this.state.isOpenModalGHRS && (
          <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
            <ModalHeader className="margin-modal" title={modalHeader.title} iconDescription={modalHeader.iconDescription} buttonOnClick={modalHeader.buttonOnClick}>
              <p />
            </ModalHeader>
            <ModalBody className="margin-modal">
              <div className="bx--grid--full-width">
                <div className="bx--row">
                  {this.state.isSaveCar && <Loading />}

                  <Form className="bx--grid--full-width form--multi ">
                    {this.state.isLoadingElement ? <Loading /> : ''}
                    <div className="bx--row ">
                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Due Date*</FormLabel>
                        {this.state.isLoadingDate ? (
                          <DatePickerSkeleton />
                        ) : (
                          <DateTimePicker
                            value={this.state.carModel.duedate}
                            type="date"
                            placeholder={DateFormat}
                            name="dueDate"
                            alt="carModel"
                            invalid={
                              validationCar.dueDate != null || validationCar.duedate != null
                            }
                            onChange={this.updateStateDPCAR}
                          />
                        )}

                        {validationCar.dueDate}
                        {validationCar.duedate ? (
                          <div className="srv-validation-message">
                            {' '}
                            Date of the event less than the date of execution
                            {' '}
                          </div>
                        ) : null}
                      </FormGroup>

                      <FormGroup legendText="Find Owner on GHRS*" className="bx--col-md-4">
                        <div className="bx--row two-button-center">
                          <div className="bx--col-lg-6 bx--col-md-6">
                            <Button
                              kind="primary"
                              className="bx--col"
                              onClick={() => this.showGHRS()}
                            >
                              GHRS research
                            </Button>
                          </div>
                          <div className="bx--col-lg-6 bx--col-md-6">
                            <Button
                              kind="primary"
                              className="bx--col"
                              onClick={() => this.handleChangeMode(2)}
                            >
                              Saipem research
                            </Button>
                          </div>
                        </div>
                        {validationCar.email}
                      </FormGroup>
                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Owner Full Name*</FormLabel>
                        <TextInput
                          id="idEmployer"
                          name="idEmployer"
                          placeholder="Search Car Owner"
                          required
                          value={
                            this.state.ownerModel?.fullname ? this.state.ownerModel?.fullname : ''
                          }
                          type="text"
                          labelText=""
                          className="bx--text-input  bx--text-input--light camp--description "
                          disabled
                          //  invalid={validations.descriptionCar != null}
                        />
                      </FormGroup>
                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Owner Email*</FormLabel>
                        <TextInput
                          id="idEmployer"
                          name="idEmployer"
                          placeholder="Search Car Owner"
                          required
                          value={this.state.ownerModel.email ? this.state.ownerModel.email : ''}
                          type="text"
                          labelText=""
                          className="bx--text-input  bx--text-input--light camp--description "
                          disabled
                          //  invalid={validations.descriptionCar != null}
                        />
                      </FormGroup>
                      <FormGroup legendText="Finding Description*">
                        <TextArea
                          maxLength={5000}
                          labelText=""
                          id="inputfindingDescription"
                          name="inputfindingdescription"
                          cols={250}
                          disabled={false}
                          invalid={validationCar.findingDescription}
                          light
                          placeholder="Input Finding description"
                          rows={5}
                          value={this.state.carModel.findingDescription}
                          onChange={this.onFindingDescriptionChange}
                        />
                      </FormGroup>
                      {validationCar.findingDescription}
                      <FormGroup legendText="Details Of Inefficiency*">
                        <TextArea
                          maxLength={5000}
                          labelText=""
                          id="inputDetailOfInefficiency"
                          name="inputdetailsofinefficiency"
                          cols={250}
                          disabled={false}
                          invalid={validationCar.detailsOfInefficiency}
                          // invalidText="required"
                          light
                          placeholder="Input Details of inefficiency"
                          rows={5}
                          value={this.state.carModel.detailsOfInefficiency}
                          onChange={this.onDetailsOfInefficiencyChange}
                        />
                      </FormGroup>
                      {validationCar.detailsOfInefficiency}
                      <FormGroup legendText="Corrective Action to be implemented/Recommended action*">
                        <TextArea
                          maxLength={5000}
                          labelText=""
                          id="inputCorrectiveAction"
                          name="inputcorrectiveaction"
                          cols={250}
                          disabled={false}
                          invalid={validationCar.correctiveAction}
                          light
                          placeholder="Input Corrective Action to be implemented/Recommended action"
                          rows={5}
                          value={this.state.carModel.identifiedCorrectiveAction}
                          onChange={this.onCorrectiveActionChange}
                        />
                      </FormGroup>
                      {validationCar.correctiveAction}
                    </div>
                  </Form>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button kind="secondary" onClick={() => this.closemodalCar()}>
                Cancel
              </Button>
              <Button kind="primary" onClick={() => this.saveCar()}>
                Save
              </Button>
            </ModalFooter>
          </ComposedModal>
        )}
        {this.state.isOpenModalCar && this.state.isOpenModalGHRS && this.state.mode !== 2 && (
          <FindGHRSEmployer
            isOpenModal={this.state.isOpenModalGHRS}
            onCancel={this.handleChangeGHRSModal}
            onOk={this.setEmployer}
          />)
        }
        {this.state.isOpenModalCar && this.state.isOpenModalGHRS && this.state.mode === 2 && (
          <FindSaipemCompilers
            isOpenModal={this.state.mode === 2}
            url={`/drill/report/${this.state.drillReport?.idDrillPlan}/car/compilers/`}
            onCancel={() => this.handleChangeMode(0)}
            onOk={this.setSaipemOwner}
          />)
        }
        {/* {this.state.isOpenModalCar ? (
          !this.state.isOpenModalGHRS ? (
            <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
              <ModalHeader className="margin-modal" title={modalHeader.title} iconDescription={modalHeader.iconDescription} buttonOnClick={modalHeader.buttonOnClick}>
                <p />
              </ModalHeader>
              <ModalBody className="margin-modal">
                <div className="bx--grid--full-width">
                  <div className="bx--row">
                    {this.state.isSaveCar && <Loading />}

                    <Form className="bx--grid--full-width form--multi ">
                      {this.state.isLoadingElement ? <Loading /> : ''}
                      <div className="bx--row ">
                        <FormGroup legendText="" className="bx--col-md-4">
                          <FormLabel className="some-class">Due Date*</FormLabel>
                          {this.state.isLoadingDate ? (
                            <DatePickerSkeleton />
                          ) : (
                            <DateTimePicker
                              value={this.state.carModel.duedate}
                              type="date"
                              placeholder={DateFormat}
                              name="dueDate"
                              alt="carModel"
                              invalid={
                                validationCar.dueDate != null || validationCar.duedate != null
                              }
                              onChange={this.updateStateDPCAR}
                            />
                          )}

                          {validationCar.dueDate}
                          {validationCar.duedate ? (
                            <div className="srv-validation-message">
                              {' '}
                              Date of the event less than the date of execution
                              {' '}
                            </div>
                          ) : null}
                        </FormGroup>

                        <FormGroup legendText="Find Owner on GHRS*" className="bx--col-md-4">
                          <div className="bx--row two-button-center">
                            <div className="bx--col-lg-6 bx--col-md-6">
                              <Button
                                kind="primary"
                                className="bx--col"
                                onClick={() => this.showGHRS()}
                              >
                                GHRS research
                              </Button>
                            </div>
                            <div className="bx--col-lg-6 bx--col-md-6">
                              <Button
                                kind="primary"
                                className="bx--col"
                                onClick={() => this.handleChangeMode(2)}
                              >
                                Saipem research
                              </Button>
                            </div>
                          </div>
                          {validationCar.email}
                        </FormGroup>

                        <FormGroup legendText="" className="bx--col-md-4">
                          <FormLabel className="some-class">Owner Full Name*</FormLabel>
                          <TextInput
                            id="idEmployer"
                            name="idEmployer"
                            placeholder="Search Car Owner"
                            required
                            value={
                              this.state.ownerModel?.fullname ? this.state.ownerModel?.fullname : ''
                            }
                            type="text"
                            labelText=""
                            className="bx--text-input  bx--text-input--light camp--description "
                            disabled
                            //  invalid={validations.descriptionCar != null}
                          />
                        </FormGroup>
                        <FormGroup legendText="" className="bx--col-md-4">
                          <FormLabel className="some-class">Owner Email*</FormLabel>
                          <TextInput
                            id="idEmployer"
                            name="idEmployer"
                            placeholder="Search Car Owner"
                            required
                            value={this.state.ownerModel.email ? this.state.ownerModel.email : ''}
                            type="text"
                            labelText=""
                            className="bx--text-input  bx--text-input--light camp--description "
                            disabled
                            //  invalid={validations.descriptionCar != null}
                          />
                        </FormGroup>

                        <FormGroup legendText="Details Of Inefficiency*">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputDetailOfInefficiency"
                            name="inputdetailsofinefficiency"
                            cols={250}
                            disabled={false}
                            invalid={validationCar.detailsOfInefficiency}
                            // invalidText="required"
                            light
                            placeholder="Input Details of inefficiency"
                            rows={5}
                            value={this.state.carModel.detailsOfInefficiency}
                            onChange={this.onDetailsOfInefficiencyChange}
                          />
                        </FormGroup>
                        {validationCar.detailsOfInefficiency}
                      </div>
                    </Form>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button kind="secondary" onClick={() => this.closemodalCar()}>
                  Cancel
                </Button>
                <Button kind="primary" onClick={() => this.saveCar()}>
                  Save
                </Button>
              </ModalFooter>
            </ComposedModal>
          ) : this.state.mode !== 2 ? (
            <FindGHRSEmployer
              isOpenModal={this.state.isOpenModalGHRS}
              onCancel={this.handleChangeGHRSModal}
              onOk={this.setEmployer}
            />
          ) : (
            <FindSaipemCompilers
              isOpenModal={this.state.mode === 2}
              url={`/drill/report/${this.state.drillReport?.idDrillPlan}/car/compilers/`}
              onCancel={() => this.handleChangeMode(0)}
              onOk={this.setSaipemOwner}
            />
          )
        ) : (
          ''
        )} */}
      </>
    );
  }

  IsRowSelectable() {
    const { drillReport } = this.state;
    if (drillReport == null || drillReport.idStatus === STATUS.Consolidated) {
      return false;
    }
    return true;
  }

  //* *************** REQUIREMENT *****************// START
  showAddRequirement = (Template, Section) => {
    this.setState((oldState) => ({
      modalAddRequirementVisible: !oldState.modalAddRequirementVisible,
      addRequirementTemplate: Template,
      addRequirementSection: Section,
    }));
  };

  showDeleteRequirement(id) {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: id,
    }));
  }

  showModifyRequirement = (idCheckListAnswer, requirement) => {
    this.setState((oldState) => ({
      modalUpdateRequirementVisible: !oldState.modalUpdateRequirementVisible,
      requirementToModify: requirement,
      checkListRequirementToModify: idCheckListAnswer,
      checkListRequirementToModifyTemplate: null, //RITM1267587
    }));
  };

  showModifyRequirementTemplate = (idCheckListAnswer, requirement, templateId) => {
    this.setState((oldState) => ({
      modalUpdateRequirementVisible: !oldState.modalUpdateRequirementVisible,
      requirementToModify: requirement,
      checkListRequirementToModify: idCheckListAnswer,
      checkListRequirementToModifyTemplate: templateId
    }));
  };

  checkListRequirementUpdated = (item) => {
    const { drillCheckListRequirementAnswers } = this.state.drillReport;
    const index = drillCheckListRequirementAnswers.findIndex(
      (qa) => qa.requirement?.id === item?.id
    );
    drillCheckListRequirementAnswers[index].requirement = item;
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalUpdateRequirementVisible = !prevState.modalUpdateRequirementVisible;
      state.isSubmitted = false;
      state.drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      // this.repository.updateCachedAudit(this.state.inspectionModel);      TODO
      return state;
    });
  };

  newCheckListRequirementAdded = (item) => {
    const { drillCheckListRequirementAnswers } = this.state.drillReport;
    let count = 0;
    // for (const answer in drillCheckListRequirementAnswers) {
    //   if (answer != null) count += 1;
    // }
    Object.keys(drillCheckListRequirementAnswers).forEach((key) => {
      if (drillCheckListRequirementAnswers[key] != null) count += 1;
    });
    drillCheckListRequirementAnswers[count] = item;
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalAddRequirementVisible = !prevState.modalAddRequirementVisible;
      state.isSubmitted = false;
      state.drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      // this.repository.updateCachedAudit(this.state.inspectionModel);      TODO
      return state;
    });
  };

  handleRequirementDeleteCancel = () => {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: null,
    }));
  };

  handleRequirementDelete = async () => {
    this.setState({ isDeletingReq: true });
    //RITM1267587
    try{
      await this.props.requirementDelete(this.state.requirementToDelete);
      const { drillCheckListRequirementAnswers } = this.state.drillReport;

      const index = drillCheckListRequirementAnswers.findIndex(
        (qa) => qa.requirement?.id === this.state.requirementToDelete
      );
      drillCheckListRequirementAnswers.splice(index, 1);
      console.log(drillCheckListRequirementAnswers);
      this.setState((prevState) => {
        const drillReport = { ...prevState.drillReport };
        drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
        return { drillReport };
      });
    }
    catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.EMERGENCYDRILL_REQ, apioperation.DELETE));
    }
    finally{
      this.setState((oldState) => ({
        modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
        requirementToDelete: null,
        isDeletingReq: false,
      }))
    };
  //End
  };

  renderRequirementDeleteModal = () => {
    const modalHeader = {
      title: 'Delete Custom Requirement',
      iconDescription: 'Close',
      buttonOnClick: () => this.handleRequirementDeleteCancel(),
    };
    return (
      this.state.modalDeleteRequirementVisible && (
        <ComposedModal
          className="light-modal"
          open
          danger="false"
          onClose={() => {
            this.handleRequirementDeleteCancel();
          }}
        >
          <ModalHeader className="margin-modal" title={modalHeader.title} iconDescription={modalHeader.iconDescription} buttonOnClick={modalHeader.buttonOnClick}>
            <p />
          </ModalHeader>
          {this.state.isDeletingReq ? <Loading /> : ''}
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">
                    Press confirm to delete selected custom requirement
                  </h5>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={this.handleRequirementDeleteCancel}>
              Cancel
            </Button>
            <Button kind="primary" onClick={this.handleRequirementDelete}>
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      )
    );
  };

  getRequirementAnswer = () => {
    const result = [];
    if (this.state.drillReport.drillCheckListRequirementAnswers) {
      this.state.drillReport.drillCheckListRequirementAnswers.forEach((item) => {
        if (item.requirement && item.requirement.idDrillCheckListTemplate === null) result.push(item); //RITM1267587
      });
    }
    return result;
  };

  getRequirementAnswerTemplate = (templateId) => {
    const result = [];
    if (this.state.drillReport.drillCheckListRequirementAnswers) {
      this.state.drillReport.drillCheckListRequirementAnswers.forEach((item) => {
        if (item.requirement && item.requirement.idDrillCheckListTemplate === templateId) {
          result.push(item);
        }
      });
    }
    return result;
  };
  //* *************** REQUIREMENT *****************// END

  //* *************** ANSWER *****************// START
  onAnswerChange = (id, answer) => {
    const { drillCheckListRequirementAnswers } = this.state.drillReport;
    const index = drillCheckListRequirementAnswers.findIndex((qa) => qa.id === id);
    if (drillCheckListRequirementAnswers[index].idAnswer !== answer.id) {
      drillCheckListRequirementAnswers[index].idAnswer = answer.id;
      drillCheckListRequirementAnswers[index].answer = answer;
    } else drillCheckListRequirementAnswers[index].idAnswer = null;
    this.setState((prevState) => {
      const drillReport = {
        ...prevState.drillReport,
      };
      drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      return { drillReport };
    });
  };

  onNoteChange(id, note) {
    note.preventDefault();
    const { drillCheckListRequirementAnswers } = this.state.drillReport;
    const index = drillCheckListRequirementAnswers.findIndex((qa) => qa.id === id);
    drillCheckListRequirementAnswers[index].notes = note.target.value;
    this.setState((prevState) => {
      const drillReport = {
        ...prevState.drillReport,
      };
      drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
      return { drillReport };
    });
  }
  //* *************** ANSWER *****************// END

  //* *************** CAR *****************// START
  getCar(qa, user) {
    return (
      <>
        {!qa.car ? (
          <Button
            className="selection-item "
            disabled={
              this.props.editingDisabled
              // ||
              // qa.answer?.name == "Yes" ||
              // qa.answer?.name == "N/A" ||
              // qa.answer?.name == undefined
            }
            id={`btn${qa.id}`}
            key={`btn${qa.id}`}
            size="small"
            kind="tertiary"
            renderIcon={Add16}
            onClick={() => this.showModalCar(qa.id, qa.question?.code)}
          >
            Associate CAR
          </Button>
        ) : (
          <>
            <ConfirmAlertCustom 
              idToDelete={this.state.idToDelete}
              nameItem="CAR"
              isDeleting={this.state.isDeleting}
              open={this.state.isOpenDeleteModal} // open state
              onCloseConfirm={this.onCloseConfirm} // no click
              deleteItem={() => 
                this.onDeleteCar(this.state.idAnswerToDelete, this.state.idToDelete)}
            />

            <div className="selection-item ">
              <div className="dox-actions-detail">{qa.car.drillCARCode}</div>
              {IsEditable(
                'Emergency Drill',
                'CARSimplified',
                user,
                qa.car.idStatus,
                'DueDate',
                this.props.drillReport
              ) && (this.IsRowSelectable() || IsInRole(user, 'Administrator')) ? ( //RITM1095892
                <>
                  <Button
                    key={qa.car.id}
                    id={qa.car.id}
                    size="small"
                    renderIcon={Edit16}
                    iconDescription="Edit"
                    onClick={() => this.showModalUpdateCar(qa.id, qa.car)}
                    kind="ghost"
                    className="checklist-custom-content-detail"
                    disabled={this.props.disabled}
                  />
                  <Online>
                    <Button
                      key={qa.car.id}
                      id={qa.car.id}
                      size="small"
                      renderIcon={Delete16}
                      iconDescription="Delete"
                      onClick={() =>
                        this.confirmDeleteCAR(qa.car.id, qa.car.idDrillCheckListRequirementAnswer)
                      }
                      kind="ghost"
                      className="checklist-custom-content-info "
                      disabled={this.props.disabled}
                    />
                  </Online>
                  <Offline>
                    <Button
                      size="small"
                      renderIcon={Delete16}
                      iconDescription="Delete"
                      kind="ghost"
                      disabled
                    />
                  </Offline>
                </>
              ) : null}
              <Link to={`answer/car/${qa.car.id}`}>
                <Button
                  size="small"
                  renderIcon={View16}
                  title="View CAR"
                  iconDescription="View CAR"
                  kind="ghost"
                />
              </Link>
              <StatusTag
                value={qa.car.status && qa.car.status.carSimplifiedName}
                className="item-tag-inline"
              />
            </div>
          </>
        )}
      </>
    );
  }

  onDeleteCar = (idAnswer, id) => {
    this.setState({
      isDeleting: true,
    });
    api
      .delete(`/drill/report/${this.state.drillReport.id}/answer/${idAnswer}/car/${id}`, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.EMERGENCYDRILL_CAR, apioperation.DELETE)
          );

          const { drillCheckListRequirementAnswers } = this.state.drillReport;

          const index = drillCheckListRequirementAnswers.findIndex((qa) => qa.id === idAnswer);

          drillCheckListRequirementAnswers[index].car = null;
          this.onCloseConfirm();
          this.setState((prevState) => {
            const state = { ...prevState };
            state.drillReport.drillCheckListRequirementAnswers = drillCheckListRequirementAnswers;
            // this.repository.updateCachedAudit(this.state.inspectionModel);      TODO

            return state;
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_CAR, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };
  //* *************** CAR *****************// END

  renderContent = (user) => (
    <>
      {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
        <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
          <Button
            size="default"
            renderIcon={Save16}
            kind="primary"
            onClick={this.updateCheckList}
            disabled={this.state.editingDisabled}
          >
            Save
          </Button>
        </div>
      )}
      {this.modalCar()}
      {this.modalAttachment(user)}
      {this.renderRequirementDeleteModal()}
      {this.state.modalAddRequirementVisible ? (
        <CheckListRequirement
          CheckList={this.state.drillReport}
          Section={{}}
          Template={this.state.addRequirementTemplate || null}
          onSave={this.newCheckListRequirementAdded}
          onCancel={this.showAddRequirement}
          idDrillReport={this.state.drillReport.id} //RITM1424427
        />
      ) : null}
      {this.state.modalUpdateRequirementVisible ? (
        <CheckListRequirement
          idCheckListAnswer={this.state.checkListRequirementToModify}
          Template={this.state.checkListRequirementToModifyTemplate}
          Requirement={this.state.requirementToModify}
          onUpdate={this.checkListRequirementUpdated}
          onCancel={this.showModifyRequirement}
        />
      ) : null}

      <Tabs>
        <Tab
          href="#"
          label="General Assesment"
          onClick={() => {}}
          onKeyDown={() => {}}
          role="presentation"
          selected={false}
          tabIndex={0}
          id={0}
          key={0}
        >
          <div className="bx--row">
            {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
              <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-detail ">
                <Button
                  disabled={this.props.editingDisabled}
                  renderIcon={Add16}
                  onClick={() => this.showAddRequirement()}
                >
                  Add Requirement
                </Button>
              </div>
            )}
          </div>
          {this.state.drillReport.drillCheckListRequirementAnswers
        ?.filter((a) => a.idQuestion != null && a.question?.idDrillCheckListTemplate == null)  
        .map((qa) => (
          <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
            <CheckListQuestionAnswer
              id={qa.id}
              key={qa.id}
              questionCode={qa.question?.code}
              question={qa.question?.name}
              answer={qa.idAnswer}
              note={qa.notes}
              disabled={this.props.editingDisabled}
              onAnswerChange={this.onAnswerChange}
              onNoteChange={(note) => this.onNoteChange(qa.id, note)}
              validator={this.validationsAnswer}
            />
            <div className="bx--row">
              <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 selection-linear">
                {this.getCar(qa, user)}
              </div>
              <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 requirement-answer-attachment">
                {qa.attachments && qa.attachments.length > 0 ?
                  <Attachment16
                    className="requirement-answer-attachment-icon"
                    aria-label="Attachment loaded"
                    role="img"
                  />
                  : null}
                <Button
                  kind="primary"
                  size="small"
                  renderIcon={Attachment16}
                  onClick={() => this.showModalAttachment(qa.id)}
                >
                  Attachments
                </Button>
              </div>
            </div>
          </div>
        ))}

          {this.getRequirementAnswer().map((qa) => (
            <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
              <CheckListQuestionAnswer
                id={qa.id}
                key={qa.id}
                questionCode={qa.requirement.code}
                question={qa.requirement.name}
                answer={qa.idAnswer}
                note={qa.notes}
                onAnswerChange={this.onAnswerChange}
                isCustom
                onDeleteCustomRequirement={() => this.showDeleteRequirement(qa.requirement.id)}
                onUpdateCustomRequirement={() => this.showModifyRequirement(qa.id, qa.requirement)}
                onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                disabled={this.props.editingDisabled}
                validator={this.validationsAnswer}
              />
              <div className="bx--row">
                <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 selection-linear">
                  {this.getCar(qa, user)}
                </div>
                <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 requirement-answer-attachment">
                  {qa.attachments && qa.attachments.length > 0 ?
                    <Attachment16
                      className="requirement-answer-attachment-icon"
                      aria-label="Attachment loaded"
                      role="img" 
                    />
                    : null}
                  <Button
                    className="button-items--modal "
                    kind="primary"
                    size="small"
                    renderIcon={Attachment16}
                    onClick={() => this.showModalAttachment(qa.id)}
                  >
                    Attachments
                  </Button>
                </div>
              </div>
            </div>
      ))}

        </Tab>
        {this.state.drillReport.drillCheckListRequirementAnswers
         && this.getTemplate().map((template) => (
          
           <Tab
             href="#"
             label={template.name}
             className={`${template.active ? 'bx--tabs__nav-link_is_active' : 'bx--tabs__nav-link_is_not_active'} `}
             onClick={() => { }}
             onKeyDown={() => { }}
             role="presentation"
             selected={false}
             tabIndex={0}
             id={0}
             key={0}
           >
             {!template.active && 
             <div> 
               {`Click the following button to enable the checklist in accordance with: ${template.name}`}
             </div>}
             <Toggle
               toggled={template.active}
               onToggle={() => this.toggleActiveTemplateQuestions(template.id)}
               className="toggle-bg-orange mb-20px"
               labelText="Template Enabled"
               aria-label=""
               disabled={this.props.editingDisabled}
               id={`toggle-1 - ${template.id}`}
             />
             <div className="bx--row">
               {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) && ( //RITM1064131
               <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-detail ">
                 <Button
                   disabled={this.props.editingDisabled || !template.active}
                   renderIcon={Add16}
                   onClick={() => this.showAddRequirement(template.id)}
                 >
                   Add Requirement
                 </Button>
               </div>
                )}
             </div>
             {this.state.drillReport.drillCheckListRequirementAnswers
              ?.filter((a) => a.idQuestion != null && a.question.idDrillCheckListTemplate != null 
                              && a.question.idDrillCheckListTemplate === template.id)
              .map((qa) => (
                <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
                  <CheckListQuestionAnswer
                    id={qa.id}
                    key={qa.id}
                    questionCode={qa.question?.code}
                    question={qa.question?.name}
                    answer={qa.idAnswer}
                    note={qa.notes}
                    disabled={this.props.editingDisabled || !template.active}
                    onAnswerChange={this.onAnswerChange}
                    onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                    required={false}
                    validator={this.validationsAnswer}
                  />
                  <div className="bx--row">
                    <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 selection-linear">
                      {this.getCar(qa, user)}
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 requirement-answer-attachment">
                      {qa.attachments && qa.attachments.length > 0 ?
                        <Attachment16
                          className="requirement-answer-attachment-icon"
                          aria-label="Attachment loaded"
                          role="img"
                          disabled={!template.active}
                        />
                        : null}
                      <Button
                        kind="primary"
                        size="small"
                        renderIcon={Attachment16}
                        onClick={() => this.showModalAttachment(qa.id)}
                        disabled={!template.active}
                      >
                        Attachments
                      </Button>
                    </div>
                  </div>
                </div>
              ))}

             {this.getRequirementAnswerTemplate(template.id).map((qa) => (
               <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
                 <CheckListQuestionAnswer
                   id={qa.id}
                   key={qa.id}
                   questionCode={qa.requirement.code}
                   question={qa.requirement.name}
                   answer={qa.idAnswer}
                   note={qa.notes}
                   onAnswerChange={this.onAnswerChange}
                   isCustom
                   onDeleteCustomRequirement={() => this.showDeleteRequirement(qa.requirement.id)}
                   onUpdateCustomRequirement={() => 
                     this.showModifyRequirementTemplate(qa.id, qa.requirement, template.id)}
                   onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                   disabled={this.props.editingDisabled || !template.active}
                   required={false}
                   validator={this.validationsAnswer}
                 />
                 <div className="bx--row">
                   <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 selection-linear">
                     {this.getCar(qa, user)}
                   </div>
                   <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 requirement-answer-attachment">
                     {qa.attachments && qa.attachments.length > 0 ?
                       <Attachment16
                         className="requirement-answer-attachment-icon"
                         aria-label="Attachment loaded"
                         role="img"
                       />
                    : null}
                     <Button
                       className="button-items--modal "
                       kind="primary"
                       size="small"
                       renderIcon={Attachment16}
                       onClick={() => this.showModalAttachment(qa.id)}
                       disabled={!template.active}
                     >
                       Attachments
                     </Button>
                   </div>
                 </div>
               </div>
            ))}
           </Tab>
        ))}
      </Tabs>

    </>
  );

  render() {
    return this.props.drillReport ? (
      <AppContext.Consumer>
        {({ user }) => (IsEnabled(user, 'Emergency Drill') ? <>{this.renderContent(user)}</> : '')}
      </AppContext.Consumer>
    ) : (
      <></>
    );
  }
}
export default DrillReportSummary;

DrillReportSummary.propTypes = {
  editingDisabled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  updateAnswers: PropTypes.func.isRequired,
  deleteAnswerAttachment: PropTypes.func.isRequired,
  downloadAnswerAttachment: PropTypes.func.isRequired,
  uploadAnswerAttachment: PropTypes.func.isRequired,
  requirementDelete: PropTypes.func.isRequired,
  drillReport: PropTypes.shape({
    id: PropTypes.instanceOf(uuid),
    sequence: PropTypes.number,
    drillReportCode: PropTypes.string,
    name: PropTypes.string,
    lcuReference: PropTypes.string,
    scenarioDescription: PropTypes.string,
    overallAssessmentNotes: PropTypes.string,
    isSatisfactory: PropTypes.bool,
    referenceProcedure: PropTypes.string,
    deliveryDate: PropTypes.instanceOf(Date),
    isInPlannedWeek: PropTypes.bool,
    deliveryDateWithWeek: PropTypes.string,
    plannedWeekWithDate: PropTypes.string,
    idDrillPlan: PropTypes.instanceOf(uuid),
    idStatus: PropTypes.number,
    compilerAssignStatus: PropTypes.string,
    idLightCondition: PropTypes.instanceOf(uuid),
    idSeaCondition: PropTypes.instanceOf(uuid),
    idWeatherCondition: PropTypes.instanceOf(uuid),
    idEmergencyLevel: PropTypes.instanceOf(uuid),
    temperature: PropTypes.number,
    temperatureScale: PropTypes.string,
    windSpeed: PropTypes.number,
    equipmentUsed: PropTypes.string,
    distributionList: PropTypes.string,
    poB_BOS: PropTypes.number,
    pointsOfStrength: PropTypes.string,
    notes: PropTypes.string,
    needsToRepeat: PropTypes.bool,
    drillPlan: PropTypes.object,
    status: PropTypes.object,
    lightCondition: PropTypes.object,
    seaCondition: PropTypes.object,
    weatherCondition: PropTypes.object,
    drillEmergencyLevel: PropTypes.object,
    drillNotificationForm: PropTypes.object,
    division: PropTypes.object,
    company: PropTypes.object,
    workSite: PropTypes.object,
    participant: PropTypes.object,
    drillTypeDetail: PropTypes.object,
    drillType: PropTypes.object,
    drillReportPlannedWeeks: PropTypes.arrayOf(PropTypes.object),
    drillCheckListRequirementAnswers: PropTypes.arrayOf(PropTypes.object),
    attachments: PropTypes.arrayOf(PropTypes.object),
    people: PropTypes.arrayOf(PropTypes.object),
    unitsInvolved: PropTypes.arrayOf(PropTypes.object),
    timelines: PropTypes.arrayOf(PropTypes.object),
    drillReportProjects: PropTypes.arrayOf(PropTypes.object),
    projects: PropTypes.arrayOf(PropTypes.object)
  })
};
DrillReportSummary.defaultProps = { 
  disabled: false,
  drillReport: null
 };
